import { useState } from 'react';
import { ArrowLeftRight, PlusCircle, ThreeDotsVertical } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';
import Table, { Column } from '../../../Components/Tables/Table';
import { inventoryadjustmentlist } from '../../../Data/testData';
import PageHeader from '../../../Layout/PageHeader';
import ImportLayout from "../../../Layout/ImportLayout";
import ExportLayout from "../../../Layout/ExportLayout";
import CommonModal from '../../../Components/Modals/CommonModal';

export default function AdjustmentOverview() {
  const pageName = "Inventory Adjustment Overview";

  const navigation = useNavigate();
  const [showModalForImportAndExport, setShowModalForImportAndExport] =
  useState({
    importModal: false,
    exportModal: false,
  });
  const [isAddButtonDisable, setAddButtonDisable] = useState(false);
  
  const handleRowClick = (data: any) => {
    navigation(`/inventory/inventory-adjustment-history/${data.adjustmentCode}`);
  };
  const handelSelectRows = (selectedRow: Set<number>) => {
    setAddButtonDisable(selectedRow.size > 0);
  };
  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShow(!show);
  const closeDeleteKitModal = () => {
    setShowModal(false);
  };

  const columns: Column[] = [
    {
      name: "Adjustment #",
      selector: (row: { adjustmentCode: string }) => (
        <span className='text-primary' onClick={() => handleRowClick(row)} style={{ cursor: 'pointer' }}>
          {row.adjustmentCode}
        </span>
      ),
      enableSorting: true, 
    },
    {
      name: "Created By",
      selector: (row: { createdBy: string }) => row.createdBy,
    },
    {
      name: "Completed Date",
      selector: (row: { complementDate: string }) => row.complementDate,
    },
    {
      name: "Status",
      selector: (row: { status: string }) => {
          return row.status === "new" ? (
              <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
                  New
              </span>
          ) : row.status === "pending_review" ? (
              <span className="badge text asn-overview-status w-70 asn-overview-status-border-red">
                  Pending Review
              </span>
          ) : row.status === "completed" ? (
              <span className="badge asn-overview-status w-70 asn-overview-status-border-green">
                  Completed
              </span>
          ) : row.status === "in progress" ? (
              <span className="badge asn-overview-status w-70 asn-overview-status-border-yellow">
                  In Progress
              </span>
          ) : (
              <></>
          );
      },
    },
        {
            name: (
                <>
                    <ArrowLeftRight className="me-2" /> <PlusCircle />
                </>
            ),
            selector: (row: any) => (
                <>
                    <span
                        className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <ThreeDotsVertical />
                    </span>
                    <ul className="dropdown-menu action-items px-0 py-1">
                        <li
                            className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
                            onClick={() => handleRowClick(row)}
                        >
                            Detail Screen
                        </li>
                    </ul>
                </>
            ),
        },
  ];

  return (
    <>
      <PageHeader
                name="Create"
                isShowUpload={true}
                addUrl="/inventory/inventory-adjustment/create"
                setShowModalForImportAndExport={setShowModalForImportAndExport}
                showModalForImportAndExport={showModalForImportAndExport}
            />

      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div className="inbound-CheckIn-Table-Main-Div"></div>
      <Table
        columns={columns}
        data={inventoryadjustmentlist}
         pagination={{
          recordsPerPage: 15,
          totalRecords: inventoryadjustmentlist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
        onSelectedRowsChange={handelSelectRows}
        CheckboxStatus={true}
        enableSorting={true}
      />
      <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
    </>
  )
}
